import request from '@/utils/request'

//新闻资讯列表
export const consultMangae = (params) => {
    return request({
        url: `/hqprotal/consultManage/list`,
        method: 'get',
        params
    })
}

//新闻资讯详情
export const consultDetails = (id) => {
    return request({
        url: `/hqprotal/consultManage/getInfo/${id}`,
        method: 'get',
    })
}

//查询商品管理列表

export const productManagement = (params) => {
    return request({
        url: `/hqprotal/productManagement/list`,
        method: 'get',
        params
    })
}

//产品商城详情
export const productDetails = (id) => {
    return request({
        url: `/hqprotal/productManagement/getInfo/${id}`,
        method: 'get',
    })
}

//查询商品管理列表

export const productsearch = (params) => {
    return request({
        url: `/hqprotal/productManagement/list`,
        method: 'get',
        params
    })
}


//查询工厂
export const selectPlantList = (params) => {
    return request({
        url: `/hqprotal/manage/selectPlantList`,
        method: 'get',
        params
    })
}

//收藏产品
export const productCollect = (params) => {
    return request({
        url: `/hqprotal/productManagement/productCollect`,
        method: 'get',
        params
    })
}
//收藏产品列表
export const getCollectByUser = () => {
    return request({
        url: `/hqprotal/productManagement/getCollectByUser`,
        method: 'get',
    })
}

//查询单个工厂信息
export const facDetail = (params) => {
    return request({
        url: `/hqprotal/manage/getPlantInfoByPlantId`,
        method: 'get',
        params
    })
}



